import React, { forwardRef, createElement } from 'react';
import getDisplayName from 'react-display-name';
import hoistNonReactStatic from 'hoist-non-react-statics';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function createHocRef(fn) {
  var opt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var name = opt.name,
      _opt$enableRef = opt.enableRef,
      enableRef = _opt$enableRef === void 0 ? false : _opt$enableRef,
      _opt$blacklist = opt.blacklist,
      blacklist = _opt$blacklist === void 0 ? [] : _opt$blacklist;

  var _blacklist = blacklist.reduce(function (rt, cur) {
    return rt[cur] = true, rt;
  }, {});

  return function (WrappedComponent) {
    var _NewComponent = fn(WrappedComponent);

    return returnWithApp(_NewComponent);

    function returnWithApp(NewComponent) {
      if (enableRef && forwardRef) {
        var forwarded = forwardRef(function forwardHocRef(props, ref) {
          return createElement(NewComponent, _objectSpread2(_objectSpread2({}, props), {}, {
            ReactforwardedRef: ref
          }));
        });
        forwarded.displayName = "".concat(name || NewComponent.name || 'createHocRef', "(").concat(getDisplayName(WrappedComponent), ")");
        return hoistNonReactStatic(forwarded, WrappedComponent, _blacklist);
      }

      return hoistNonReactStatic(NewComponent, WrappedComponent, _blacklist);
    }
  };
}

var RuntimeContext = React.createContext({});
var Consumer = RuntimeContext.Consumer,
    Provider = RuntimeContext.Provider;

var isNode = typeof process !== 'undefined' && process.versions != null && process.versions.node != null && process.versions.electron == null;
function isDev() {
  return !(process.env.NODE_ENV === 'production');
}
function isString(str) {
  return typeof str === 'string';
}
function isUndefined(obj) {
  return typeof obj === 'undefined';
}
function isArray(obj) {
  return Object.prototype.toString.call(obj) === '[object Array]';
}
function isFunction(func) {
  return typeof func === 'function';
}
function isObject(obj) {
  return _typeof(obj) === 'object';
}
function isPlainObject(obj) {
  return obj && _typeof(obj) === 'object' && Object.prototype.toString.call(obj) === '[object Object]';
}
function isPromise(obj) {
  /* eslint-disable promise/prefer-await-to-then */
  return Boolean(obj) && (_typeof(obj) === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
  /* eslint-enable promise/prefer-await-to-then */
}

function uniqueId() {
  return (new Date().valueOf() + Math.random()).toString();
}
var globalUniqueId = uniqueId();

function pluginSpecialHookHelper(_ref) {
  var _ref$plugins = _ref.plugins,
      plugins = _ref$plugins === void 0 ? [] : _ref$plugins;
  return {
    composeOnCreateApp: function composeOnCreateApp(AppComponent, config) {
      return plugins.reduce(function (_AppComponent, plugin) {
        var specialHook = plugin.__SPECIALHOOK__;
        return specialHook && specialHook.onCreateApp ? specialHook.onCreateApp(_AppComponent, config) : _AppComponent;
      }, AppComponent);
    }
  };
}

export { Consumer, Provider, RuntimeContext, createHocRef, globalUniqueId, isArray, isDev, isFunction, isNode, isObject, isPlainObject, isPromise, isString, isUndefined, pluginSpecialHookHelper, uniqueId };
//# sourceMappingURL=utils.esm.js.map
